<template>
	<el-table
			v-if=" !loading &&tableData.length > 0 "
			height="100%"
			:data="tableData"
			style="width: 100%">
		<el-table-column
				fixed
				prop="name"
				label="名称"
				width="220"
		>
		</el-table-column>

		<el-table-column
			fixed
			prop="total"
			:label="'总'+type+'电量'"
			width="180">
			<template slot-scope="scope">
				<template  v-if="node=='water'">
					<template v-if="scope.row.id!=30">
						--
					</template>
					<template v-else>
						{{scope.row.total}}<span v-if="node=='electricity'">kWh</span><span v-else-if="node=='water'">m³</span><span v-else>GJ</span>
					</template>
				</template>
				<template  v-else>
					{{scope.row.total}}<span v-if="node=='electricity'">kWh</span><span v-else-if="node=='water'">m³</span><span v-else>GJ</span>
				</template>
			</template>
		</el-table-column>

		<el-table-column
			v-for="(item, index) in titles"
			:key="index"
			:prop="item"
			width="110"
			:label="item">
			<template slot-scope="scope" >
				<template v-if="node=='water'">
					<template v-if="scope.row.id!=30">
						--
					</template>
					<template v-else>
						{{scope.row[item]}}<span v-if="scope.row[item]!='--'"><span v-if="node=='electricity'">kWh</span><span v-else-if="node=='water'">m³</span><span v-else>GJ</span></span>
					</template>
				</template>
				<template v-else>
					{{scope.row[item]}}<span v-if="scope.row[item]!='--'"><span v-if="node=='electricity'">kWh</span><span v-else-if="node=='water'">m³</span><span v-else>GJ</span></span>
				</template>
			</template>
			
		</el-table-column>

	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {floatFormat} from "../../../util/MathUtil"
	import {currentDay, monthDays,weekStart,weekEnd,dateFormat} from "../../../util/DateUtil";
	import {classifiedEnergyConsumption} from "../../../api/power";
	import exportExcel from "../../../util/excel";
	import Axios from "axios"
	import dict from "../../../util/dict"
	export default {
		props: {
			loops: Array,
			range: String,
			date: Date,
			node:String
		},
		name: "Running",
		data() {
			return {
				loading: false,
				titles: [],
				tableData:[],
				type:"电",
			}
		},
		mounted() {
			this.requestData();
			switch (this.range) {
				case "day":
					this.titles = []
					for (let i = 0; i < 24; i++) {
						this.$set(this.titles, i, i < 10 ? '0' + i + ':00' : i + ':00')
					}
					break;
				case "month":
					this.titles = []
					for (let i = 0; i < monthDays(this.date); i++) {
						this.$set(this.titles, i, i + 1 + '日')
					}
					break;
				case "week":
					this.titles = []
					let startDate = weekStart(this.date).replace('T00:00:00Z',"")
					let endDate = weekEnd(this.date).replace('T00:00:00Z',"")
					let time = this.getDiffDate(startDate,endDate)
					for (let i = 0; i < time.length; i++) {
						this.$set(this.titles, i, time[i])
					}
					break;
				case "year":
					this.titles = []
					for (let i = 0; i < 12; i++) {
						this.$set(this.titles, i, i + 1 + '月')
					}
					break;
			}
		},
		computed: {
			propsData(){
				return [
					this.date,
					this.range,
					this.loops,
					this.node
				]
			},
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			
		},
		watch: {
			propsData(){
                switch (this.range) {
                    case "day":
                        this.titles = []
                        for (let i = 0; i < 24; i++) {
                            this.$set(this.titles, i, i < 10 ? '0' + i + ':00' : i + ':00')
                        }
                        break;
                    case "month":
                        this.titles = []
                        for (let i = 0; i < monthDays(this.date); i++) {
                            this.$set(this.titles, i, i + 1 + '日')
                        }
                        break;
                    case "week":
                        this.titles = []
						let startDate = weekStart(this.date).replace('T00:00:00Z',"")
						let endDate = weekEnd(this.date).replace('T00:00:00Z',"")
						let time = this.getDiffDate(startDate,endDate)
                        for (let i = 0; i < time.length; i++) {
                            this.$set(this.titles, i, time[i])
                        }
                        break;
                    case "year":
                        this.titles = []
                        for (let i = 0; i < 12; i++) {
                            this.$set(this.titles, i, i + 1 + '月')
                        }
                        break;
                }
				
				this.requestData();
            },
			diagramStatus(n){
				if(this.$route.params.name === 'Extremum' && this.$route.params.tag === 'Complex' ){
					if(n.type === 'excel' && this.tableData.length > 0){

						let data = [
							['名称', '总'+this.type+'电量']
						]

						this.titles.forEach(t => {
							data[0].push(t)
						})

						this.tableData.forEach(d => {
							data.push([d.name, d.total, ...this.titles.map(t => d[t]!='--'?d[t]+'kWh':'--')])
						})

						exportExcel(data, '用'+this.type+'量时段报表', [])

					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
			node(){
				this.type = this.class();
			}
		},
		methods: {
			class(){
				switch (this.node) {
					case 'electricity':
						return '电'
						break;
					case 'water':
						return '水'
						break;
					case 'heat':
						return '热'
						break;
					case 'cooling':
						return '冷'
						break;
					default:
						return '电'
						break;
				}
			},
			//数据
			async requestData(){
				this.loading = true;
				let range = this.range;
				let node = this.node;
				let promises = [];
				let currList = this.loops;
				currList.forEach((element) => {
					let obj = {
					buildingId: element.id,
					date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
					powerType: node.toUpperCase(),
					range: range.toUpperCase(),
					};
					promises.push(classifiedEnergyConsumption(obj));
				});
				let list = []
				Promise.all(promises).then((res) => {
					let pointsArray = res.map((r) =>
					r.data.data.result ? r.data.data.result : {}
					);
					pointsArray.forEach((item, index) => {
						let arr = item[node]
						let data = {
							name:this.loops[index].name,
							total:0,
							id:this.loops[index].id
						}
						let num = 0
						this.titles.forEach((e,i)=>{
							data[e] = arr[i]!=null?Number(arr[i]).toFixed(2):"--"
							if(arr[i]){
								num +=arr[i]
							}
						})
						data.total = Number(num).toFixed(2)
						list.push(data)
					});
					this.loading = false;
					this.tableData = list
				});
			},
			getDate(datestr) {
				var temp = datestr.split("-");
				if (temp[1] === '01') {
					temp[0] = parseInt(temp[0],10) - 1;
					temp[1] = '12';
				} else {
					temp[1] = parseInt(temp[1],10) - 1;
				}
				var date = new Date(temp[0], temp[1], temp[2]);
				return date;
			},
			getDiffDate (start, end) {
				var startTime = this.getDate(start);
				var endTime = this.getDate(end);
				var dateArr = [];
				while ((endTime.getTime() - startTime.getTime()) >= 0) {
					var year = startTime.getFullYear();
					var month = (startTime.getMonth()+1).toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
					var day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
					dateArr.push(year + "-" + month + "-" + day);
					startTime.setDate(startTime.getDate() + 1);
				}
				return dateArr;
			}
		},
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>